import { render } from "./expend.vue?vue&type=template&id=5d4b0b4c"
import script from "./expend.vue?vue&type=script&lang=js"
export * from "./expend.vue?vue&type=script&lang=js"

import exportComponent from "C:\\D\\work\\zhenbo\\code\\pay\\pay_admin_page\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__